import request from '@/utils/request'

// 查询监控时效价格分页
export function pageMonitorDurationPrice(params) {
  return request({
    url: '/cloudplant/monitorDurationPrice/page',
    method: 'post',
    params: params
  })
}

// 查询监控时效价格列表
export function listMonitorDurationPrice(query) {
  return request({
    url: '/cloudplant/monitorDurationPrice/list',
    method: 'get',
    params: query
  })
}

// 新增监控时效价格
export function addMonitorDurationPrice(data) {
  return request({
    url: '/cloudplant/monitorDurationPrice/add',
    method: 'post',
    data: data
  })
}

// 修改监控时效价格
export function updateMonitorDurationPrice(data) {
  return request({
    url: '/cloudplant/monitorDurationPrice/edit',
    method: 'post',
    data: data
  })
}

// 删除监控时效价格
export function delMonitorDurationPrice(data) {
  return request({
    url: '/cloudplant/monitorDurationPrice/delete',
    method: 'post',
    data: data
  })
}
